import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalService } from './global.service';
import { CookieService } from 'ngx-cookie-service';
import { ResponseApiModel } from '../_models/response-api.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

const API_GET_AUTHORIZATIONS = '/authorization/get-authorizations';
const API_ADD_AUTHORIZATION = '/authorization/add-authorization';
const API_EDIT_AUTHORIZATION = '/authorization/edit-authorization';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationService {

  constructor(
    private http: HttpClient,
    private globalService: GlobalService,
    private cookieService: CookieService
  ) { }

  public header() {
    return {
      headers: new HttpHeaders()
        .set('token', this.cookieService.get('_q'))
        .set('module', localStorage.getItem('authorization'))
    };
  }

  public getAuthorizations(param: { pageSize: number, page: number, filter: any }): Observable<ResponseApiModel> {
    return this.http.post<ResponseApiModel>(
      this.globalService.apiVersionHost + API_GET_AUTHORIZATIONS, param, this.header()
    ).pipe(
      map(response => response)
    );
  }

  public addAuthorization(param: {}): Observable<ResponseApiModel> {
    return this.http.post<ResponseApiModel>(
      this.globalService.apiVersionHost + API_ADD_AUTHORIZATION, param, this.header()
    ).pipe(
      map(response => response)
    );
  }

  public editAuthorization(param: {}): Observable<ResponseApiModel> {
    return this.http.post<ResponseApiModel>(
      this.globalService.apiVersionHost + API_EDIT_AUTHORIZATION, param, this.header()
    ).pipe(
      map(response => response)
    );
  }
}
